// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__35asE","rightAdornment":"Header_rightAdornment__2OloD"};